/**
 * model:
 * {
 *  "routePath": {
 *      component: "correspondingComponent",
 *      exact: true || false (OPTIONAL)
 *  }
 * }
 */

export const routes = {
  "/": {
    component: "Home"
  }
};



// WEBPACK FOOTER //
// ./src/routes/index.js